import {
  Slot
} from "@radix-ui/react-slot"
import {
  cva, type VariantProps
} from "class-variance-authority"
import * as React from "react"

import {
  cn
} from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-white text-sm font-medium ring-offset-background transition-colors focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-ring focus-visible_ring-offset-2 disabled_pointer-events-none disabled_opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-white font-roboto-medium hover_bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover_bg-destructive/90",
        outline:
          "border-1 lg_border-[2px] text-primary border-primary bg-white hover_bg-primary hover_text-white hover_border-primary",
        secondary:
          "bg-secondary text-white hover_bg-black font-roboto-medium hover_text-white",
        ghost: "hover_bg-accent hover_text-accent-foreground",
        link: "text-primary underline-offset-4 hover_underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
  VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  className, variant, size, asChild = false, ...props
}, ref) => {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      className={cn(buttonVariants({
        variant, size, className
      }))}
      ref={ref}
      {...props}
    />
  )
})

Button.displayName = "Button"

export {
  Button, buttonVariants
}

